import makeStyles from '@mui/styles/makeStyles'
import { MyAccountTheme, SignInUpLinkClasses } from '@dxp-module/themes'

const signInUpLinkStyles = makeStyles<
  MyAccountTheme,
  object,
  SignInUpLinkClasses
>(
  () => ({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    text: {
      marginRight: 4,
    },
    link: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }),
  { name: 'MyAccount_SignInUpLink' }
)

export default signInUpLinkStyles
